import React, { useState } from 'react';
import { generatePracticePlan } from '../services/aiService.simplified';
import { AiServiceError } from '../services/aiService.types';
import { LoadingOverlay } from './ui/LoadingOverlay';

const TestAI: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState<string>('');
  const [error, setError] = useState<string | null>(null);

  const handleTest = async () => {
    setIsLoading(true);
    setError(null);
    setResult('');

    try {
      console.log('Starting test with simplified AI service...');
      
      // Create a mock team and request
      const mockTeam = {
        id: 'test-team-id',
        name: 'Test Team',
        sport: 'Football',
        footballOffensiveScheme: 'Spread',
        footballDefensiveScheme: '4-3',
        rosterSize: 40,
        ageLevel: '14U',
        experienceLevel: 'Intermediate'
      };
      
      const mockRequest = {
        team: mockTeam,
        duration: 120,
        theme: 'Team Day',
        focusAreas: ['Team', 'Offense', 'Defense'],
        date: '2023-11-15',
        startTime: '16:00',
        location: 'Test Field'
      };
      
      // Call the simplified AI service
      console.log('Calling generatePracticePlan...');
      const plan = await generatePracticePlan(mockRequest);
      
      console.log('Test completed successfully!');
      setResult(JSON.stringify(plan, null, 2));
    } catch (error) {
      console.error('Test failed:', error);
      
      if (error instanceof AiServiceError) {
        setError(`AI Service Error: ${error.message} (${error.type})`);
      } else if (error instanceof Error) {
        setError(`Error: ${error.message}`);
      } else {
        setError('Unknown error occurred');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">AI Service Test</h1>
      
      <button
        onClick={handleTest}
        disabled={isLoading}
        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:bg-blue-300"
      >
        {isLoading ? 'Testing...' : 'Test AI Service'}
      </button>
      
      {error && (
        <div className="mt-4 p-4 bg-red-100 text-red-800 rounded">
          {error}
        </div>
      )}
      
      {result && (
        <div className="mt-4">
          <h2 className="text-xl font-semibold mb-2">Result:</h2>
          <pre className="p-4 bg-gray-100 rounded overflow-auto max-h-96">
            {result}
          </pre>
        </div>
      )}
      
      <LoadingOverlay
        isVisible={isLoading}
        message="Testing AI service. This may take a few seconds..."
      />
    </div>
  );
};

export default TestAI; 